import { ReduxUtils } from 'UI-Dash-Commons-UI';
import * as constants from './constants';
import MediationDocsManager from '../managers/MediationDocsManager';

export const onUpdateActiveLanguage = ReduxUtils.createAction( constants.ACTION_ON_UPDATE_ACTIVE_LANGUAGE, 'activeLanguage' );
export const onToggleCodeSnippetBackgroundStyle = ReduxUtils.createAction( constants.ACTION_ON_TOGGLE_CODE_SNIPPET_BACKGROUND_STYLE, 'codeSnippetBackgroundStyle' );

export const loadNetworks = () => dispatch =>
{
    ( new MediationDocsManager() ).loadNetworks(
        {
            reduxStateKey: 'networks',
            dispatch: dispatch
        }
    );
};

export const loadSKAdnetworkIds = () => dispatch =>
{
    ( new MediationDocsManager() ).loadSKAdnetworkIds(
        {
            reduxStateKey: 'skAdnetworkIds',
            dispatch: dispatch
        }
    );
};

export const loadSdkKey = () => dispatch =>
{
    ( new MediationDocsManager() ).loadSdkKey(
        {
            reduxStateKey: 'sdkKey',
            dispatch: dispatch
        }
    );
};

export const loadSafedkKey = () => dispatch =>
{
    ( new MediationDocsManager() ).loadSafedkKey(
        {
            reduxStateKey: 'safedkKey',
            dispatch: dispatch
        }
    );
};
